import { useSelector } from 'react-redux'
import {
    me,
    deleteUser,
    listAdmins,
    listUsers,
    resetPassword,
    dashboard,
    // userFeatureFlags, // used on the commented function
} from '../repositories/UsersRepository'
import { useAuthActions } from '../store/slices/AuthSlice'
import useGlobalLoading from './useGlobalLoading'

const useUsers = () => {
    const {
        storeDashboardInfo,
        storeUserCompanyInfo,
        storeUserLocationPreferences,
        toggleNeedReloadProfile,
    } = useAuthActions()
    const { changeLoading } = useGlobalLoading()

    const needReloadProfile = useSelector(
        state => state?.AuthSlice?.needReloadProfile,
    )

    const getProfileInfo = (onGetted, onError) => {
        return me()
            .then(onGetted)
            .catch(onError)
    }

    const getListAdmins = (onLoaded, onError) => {
        return listAdmins()
            .then(onLoaded)
            .catch(onError)
    }

    const handleResetPassword = (data, onReseted, onError) => {
        return resetPassword(data)
            .then(onReseted)
            .catch(onError)
    }

    const getListUsers = (companyId, onGetted, onError) => {
        return listUsers(companyId)
            .then(onGetted)
            .catch(onError)
    }

    const handleDeleteUser = (info, onDeletedSuccess, onError) => {
        return deleteUser(info)
            .then(() => onDeletedSuccess(info))
            .catch(onError)
    }

    const getDashboardInfo = data => {
        changeLoading(true)
        return dashboard(data)
            .then(response => {
                let dashboardInfo = response.data.dashboardInfo
                storeDashboardInfo(dashboardInfo)
                changeLoading(false)
            })
            .catch(() => {
                changeLoading(false)
            })
    }

    const saveUserCompanyInfo = data => {
        return storeUserCompanyInfo(data)
    }

    const saveUserLocationPreferences = data => {
        return storeUserLocationPreferences(data)
    }

    // Leaving this in case it can be usefull on the future
    // const getUsersFeatureFlags = data => {
    //     return userFeatureFlags(data)
    //         .then(response => {
    //             const featureFlags = response.data.featureFlags
    //             console.log(featureFlags)
    //         })
    // }

    return {
        getProfileInfo,
        getListAdmins,
        handleResetPassword,
        getListUsers,
        handleDeleteUser,
        getDashboardInfo,
        saveUserCompanyInfo,
        saveUserLocationPreferences,
        toggleNeedReloadProfile,
        // getUsersFeatureFlags,
        needReloadProfile,
    }
}

export default useUsers
